export default "__VITE_ASSET__BJUW29t2__"